import React from 'react';
import { useSelector } from 'react-redux';
import UserForm from './UserForm';
import { saveUserRequest } from '../../store/modules/users/actions';
import { selectUser } from '../../store/modules/users/selectors';
import { useActionDispatcher } from '../../hooks';

type Props = {
  showOnlyAdminSettings?: boolean;
};

const UserEdit = ({ showOnlyAdminSettings = false }: Props) => {
  const user = useSelector(selectUser);

  const saveUser = useActionDispatcher(saveUserRequest);

  return (
    <UserForm
      record={user}
      onSubmit={saveUser}
      preventCancelChanges
      backToListLink
      title={user.data?.ref.full_name_first_last || ''}
      showOnlyAdminSettings={showOnlyAdminSettings}
    />
  );
};

export default UserEdit;
